/* tslint:disable */

/**
 */
export class ViewTempSetPoint {
    ID_EQUIP?: number;
    ID_STUDY?: number;
    tr_current?: number;
    tr_new?: number;
    isComefromStudy?: number;
    FAN_FREQUENCY?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-temp-set-point.ts